/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgBudget = {
  header: 'Todos los presupuestos ({{count}})',

  code: 'Código',
  name: 'Nombre',
  active: 'Estado',
  currency: 'Divisa',
  amount: 'Importe',
  unit: 'Unidad',
  businessUnidads: 'Unidad',
  dateRange: 'Inicio - Fin',
  startDate: 'Empezar',
  endDate: 'Fin',
  actions: '',

  sortBy: 'Ordenar por',
  sort: {
    byName: 'Nombre',
    byUnitName: 'Unidad',
    byCode: 'Código',
    byValue: 'Valor',
  },

  hint: 'Los presupuestos establecen límites generales de compra y se asignan a centros de coste. Un comprador selecciona un centro de coste al finalizar la compra.',

  details: {
    title: 'Detalles del presupuesto',
    subtitle: 'Presupuesto: {{ item.name }}',
  },

  edit: {
    title: 'Editar presupuesto',
    subtitle: 'Presupuesto: {{ item.name }}',
  },

  create: {
    title: 'Crear presupuesto',
    subtitle: '',
  },

  messages: {
    deactivateTitle: 'Disable this budget?',
    deactivate:
      'Los presupuestos deshabilitados ya no se aplican a los centros de coste a los que están asignados. Asegúrese de que el centro de coste asociado tenga al menos un presupuesto.',
    confirmEnabled: 'Presupuesto {{ item.name }} habilitado correctamente',
    confirmDisabled: 'Presupuesto {{ item.name }} desactivado correctamente',
    update: 'Presupuesto {{ item.name }} actualizado con éxito',
    create: 'Presupuesto {{ item.name }} creado con éxito',
  },
  info: {
    disabledEdit: 'Habilite el presupuesto para permitir la edición.',
    disabledEnable: 'Unidad debe estar habilitada antes de que se pueda habilitar este presupuesto.',
  },

  links: {
    costCenters: 'Centros de coste',
  },

  breadcrumbs: {
    list: 'Todos los presupuestos',
    details: '{{name}}',
  },
};

export const orgBudgetAssignedCostCenters = {
  title: 'Centros de coste',
  subtitle: 'Presupuesto: {{ item.name }}',
};
